<div class="expansion-panel rounded-2xl text-color">
  <ng-content select="lib-expansion-panel-header"></ng-content>
  @if(isToggled) {
      <ng-content></ng-content>
  }
</div>